import DesenvolvimentoInfantilIcon from '@/components/icons/IndicadoresAps/eSFeAP/DesenvolvimentoInfantil.vue'

export default {
  value: 'c2',
  label: 'Desenvolvimento infantil',
  iconType: 'component',
  iconComponent: DesenvolvimentoInfantilIcon,
  buscaAtiva: {
    a: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a 1ª consulta de puericultura (prazo: até o 30º dia de vida).'
        : 'Registrar a 1ª consulta de puericultura (prazo: até o 30º dia de vida).',
    b: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para realizar e registrar a consulta de puericultura (em atraso).'
        : 'Registrar a consulta de puericultura (em atraso).',
    c: ({ perfilOdontoOuEmulti }) =>
      perfilOdontoOuEmulti
        ? 'Encaminhar para aferir e registrar peso e altura (em atraso).'
        : 'Aferir e registrar peso e altura (em atraso).',
    d: 'Acionar o Agente de Saúde para a visita domiciliar (prazo: 1ª até o 30º dia de vida e 2ª até 6 meses).',
    e: 'Encaminhar para atualizar as vacinas pentavalente, poliomielite, tríplice viral e outras.',
  },
}
